import Cookies from 'js-cookie'

const AUTH_USER_DATA = 'AUTH_USER_DATA'
const expires = { expires: 7 }

export const getUserAuthData = () => {
  const { headers } = Cookies.getJSON(AUTH_USER_DATA) || {}
  return headers || null
}

export const setUserAuthData = (data) => {
  Cookies.set(AUTH_USER_DATA, data, expires)
}

export const removeUserAuthData = () => {
  Cookies.remove(AUTH_USER_DATA)
}
